export var schema = {
  title: "Vehicle Stolen or Hijacked",
  description: "Vehicle Stolen or Hijacked Claim Form",
  type: "object",
  properties: {
    incident: {
      type: "object",
      title: "Incident",
      required: ["insureddateloss","incidentAddress","incidentDescription","incidentVehicleRecovered"],
      properties: {
        insureddateloss: {
          title: "Date and Time When Incident Occurred?",
          type: "string",
          format: "date-time"
        },
        incidentAddress: {
          type: "string",
          title: "Address Where Incident Occurred?"
        },
        incidentLat: {
          type: "string",
          title: "Latitude"
        },
        incidentLong: {
          type: "string",
          title: "Longitude"
        },
        incidentDescription: {
          type: "string",
          title: "Description of What Occurred?"
        },
        incidentVehicleRecovered: {
          type: "string",
          title: "Was the Vehicle Recovered?",
          enum: ["Yes", "No"]
        }
      },
      dependencies: {
        incidentVehicleRecovered: {
          oneOf: [{
            properties: {
              incidentVehicleRecovered: {
                enum: ["Yes"]
              },
              currentVehicleLocation: {
                type: "object",
                title: "",
                required: ["address"],
                properties: {
                  address: {
                    type: "string",
                    title: "Location of Vehicle Currently"
                  },
                  lat: {
                    type: "string",
                    title: "Latitude"
                  },
                  long: {
                    type: "string",
                    title: "Longitude"
                  }
                }
              }
            }
          }]
        }
      }
    },
    vehicleDetails: {
      type: "object",
      title: "Vehicle Details",
      required: ["vehicleMake", "vehicleModel", "vehicleYear", "vehicleRegistration"],
      properties: {
        vehicleMake: {
          type: "string",
          title: "Vehicle Make"
        },
        vehicleModel: {
          type: "string",
          title: "Vehicle Model"
        },
        vehicleYear: {
          type: "string",
          title: "Vehicle Year"
        },
        vehicleRegistration: {
          type: "string",
          title: "Registration Number"
        },
        vehicleVinNumber: {
          type: "string",
          title: "VIN Number"
        },
        vehicleEngineNumber: {
          type: "string",
          title: "Engine Number"
        }
      }
    },
    police: {
      type: "object",
      title: "Police",
      required: ["policeReported"],
      properties: {
        policeReported: {
          type: "string",
          title: "Was the Incident Reported to the Police?",
          enum: ["Yes", "No"]
        }
      },
      dependencies: {
        policeReported: {
          oneOf: [{
            properties: {
              policeReported: {
                enum: ["Yes"]
              },
              reportDetails: {
                type: "object",
                title: "Police Report Details",
                required: ["policePlaceReported", "policeDateReported", "policeCaseNumber"],
                properties: {
                  policePlaceReported: {
                    title: "Police Station Where Incident Reported",
                    type: "string"
                  },
                  policeDateReported: {
                    title: "Date Reported",
                    type: "string",
                    format: "date"
                  },
                  policeCaseNumber: {
                    title: "SAPS Case Number",
                    type: "string"
                  }
                }
              }
            }
          }, {
            properties: {
              policeReported: {
                enum: ["No"]
              },
              reportNote: {
                type: "null",
                title: "Please Report Incident to Police and Update Your Broker."
              }
            }
          }]
        }
      }
    },
    driverDetails: 
    {
      type: "object",
      title: "Full Details of Driver",
      required: ["driverIsOwner"],
      properties: 
      {
        driverIsOwner: 
        {
          type: "string",
          title: "Is the Driver the Owner of the Vehicle?",
          enum: ["Yes", "No"]
        },
        driverDetails: 
        {
                type: "object",
                title: "Details of Driver",
                required: ["driverFullName", "driverIdPassport", "driverContactNumber", "driverPermissionByInsured"],
                properties: {
                  driverFullName: {
                    type: "string",
                    title: "Driver Full Name"
                  },
                  driverIdPassport: {
                    type: "string",
                    title: "Driver ID/Passport Number"
                  },
                  driverContactNumber: {
                    type: "string",
                    title: "Driver Contact Number",
                    minLength: 10
                  },
                  driverEmail: {
                    type: "string",
                    format: "email",
                    title: "Driver Email"
                  },
                  driverPermissionByInsured: {
                    type: "string",
                    title: "Was the Driver Using the Vehicle with the Insured's Permission?",
                    enum: ["Yes", "No"]
                  }
                }
        }
      }     
    },
    witnesses: {
      type: "object",
      title: "Witnesses",
      description: "Please Add Witnesses Details",
      properties: {
        witnessList: {
          title: "Witnesses",
          type: "array",
          items: {
            type: "object",
            properties: {
              witness: {
                type: "array",
                title: "Witness",
                items: [{
                  key: "name",
                  type: "string",
                  title: "Name"
                }, {
                  key: "string",
                  type: "string",
                  title: "Contact Number",
                  minLength: 10
                }, {
                  key: "address",
                  type: "string",
                  title: "Address"
                }]
              }
            }
          }
        }
      }
    },
    injured: {
      type: "object",
      title: "Injured Persons",
      required: ["personalInjuries"],
      properties: {
        personalInjuries: {
          type: "string",
          title: "Were Any Parties Injured in the Incident?",
          enum: ["Yes", "No"]
        }
      },
      dependencies: {
        personalInjuries: {
          oneOf: [{
            properties: {
              personalInjuries: {
                enum: ["Yes"]
              },
              personalInjuriesList: {
                title: "Personal Injuries",
                description: "Please Add Injured Parties Details",
                required: ["name", "relationship"],
                type: "array",
                items: {
                  type: "object",
                  properties: {
                    person: {
                      type: "array",
                      title: "Injured Person",
                      items: [{
                        key: "name",
                        type: "string",
                        title: "Name"
                      }, {
                        key: "contactNumber",
                        type: "string",
                        title: "Contact Number",
                        minLength: 10
                      }, {
                        key: "email",
                        type: "string",
                        title: "Contact Email",
                        format: "email"
                      }, {
                        key: "idPassportNumber",
                        type: "string",
                        title: "ID/Passport Number"
                      }, {
                        key: "address",
                        type: "string",
                        title: "Address"
                      }, {
                        key: "age",
                        type: "number",
                        title: "Age"
                      }, {
                        key: "relationship",
                        title: "Relationships",
                        description: "If Person Named Above is in your Service, your Tenant, or Related to You. Please Provide Details.",
                        type: "string"
                      }]
                    }
                  }
                }
              }
            }
          }, {
            properties: {
              personalInjuries: {
                enum: ["No"]
              }
            }
          }]
        }
      }
    },
    attachments: {
      type: "object",
      title: "Attachments",
      description: `Please Attach Any of the Following Applicable Documents:
      - Police Report
      - Copy of Vehicle registration documents`,
      properties: {
        attachmentsList: {
          title: "Attachments",
          type: "array",
          items: {
            type: "object",
            properties: {
              attachment: {
                type: "array",
                title: "Attachment",
                items: [{
                  key: "attachName",
                  title: "Title",
                  type: "string",
                  maxLength: 200
                }, {
                  key: "attachmentContent",
                  type: "array",
                  title: "Attachment",
                  items: {
                    type: "string",
                    format: "data-url"
                  }
                }]
              }
            }
          }
        }
      }
    },
    declaration: {
      type: "object",
      title: "Declaration",
      required: ["insuredaccepttc"],
      description: "I/we declare that to the best of my/our knowledge the above statements are true. I acknowledge that the information set out above is provided freely so that Western may process my claim and give effect to the terms and conditions contained in the policy wording. I herewith give my consent that Western may use this information, my personal information on record and additional information obtained from other sources in order to determine whether to accept or reject my claim and take all necessary steps ancillary thereto to give effect hereto. I understand that I may be liable for output VAT in terms of section 8(8) of the VAT Act 89 of 1991.",
      properties: {
        insuredaccepttc: {
          type: "boolean",
          title: "Accept Terms and Conditions",
          description: "Tick Box to Accept Terms and Conditions"
        },
        insuredcapcity: {
          type: "string",
          title: "Capacity"
        },
        insureddate: {
          type: "string",
          title: "Date",
          format: "date"
        }
      }
    }
  }
};

export var uiSchema = {
  incidentLat: {
    "ui:widget": "hidden"
  },
  incidentLong: {
    "ui:widget": "hidden"
  },
  incidentDescription: {
    "ui:widget": "textarea",
    "ui:options": {
      rows: 5
    }
  },
  currentVehicleLocation: {
    lat: {
      "ui:widget": "hidden"
    },
    long: {
      "ui:widget": "hidden"
    }
  },
  reportDetails: {
    policePlaceReported: {
      "ui:widget": "textarea",
      "ui:options": {
        rows: 5
      }
    }
  },
  witnessList: {
    "ui:options": {
      orderable: false
    }
  },
  personalInjuriesList: {
    "ui:options": {
      orderable: false
    }
  }
};